import Styles from './style.module.scss';
import { Radio, Input, Button, Form, Row, Col, message } from 'antd';
import { useState } from 'react';
import SuggestHeader from '../../components/suggestion/suggestHeader';
import Agreement from '../../components/commonComponents/agreement';
import request from '../../utils/request/next-request';
import Success from '../../components/commonComponents/success';
import { Contact } from './consult/[type]';
import MobileFeedback from '../../components/fromComponents/feedback/MobileFeedback';
import { useUserAgentInfo } from '../../context/user-agent';
import { defaultFeedbackOptions } from '@/utils/config';
import { getFeedbackTaskOptions } from '../../services/common';

export const getServerSideProps = async (context) => {
  try {
    const res = await getFeedbackTaskOptions();
    return {
      props: { suggestTypeMap: res[1].fieldItemModels },
    };
  } catch (err) {
    return {
      props: { suggestTypeMap: defaultFeedbackOptions[1].fieldItemModels },
    };
  }
};

export default function Suggestion({ suggestTypeMap }) {
  const { isMobile } = useUserAgentInfo();
  const suggestions = {
    titleText: '投诉与建议',
    titleDesc: '填写您的需求，我们将安排专家与您建立联系',
  };
  const [agree, setAgree] = useState<boolean>(false);
  const [success, setSuccess] = useState<boolean>(false);

  const handleSubmit = async (values) => {
    delete values.agreement;
    const res = await request({
      url: `${process.env.NEXT_PUBLIC_API_BASE_URL}/feedback`,
      method: 'post',
      data: values,
    });
    if (res && res.code === 0) {
      setSuccess(true);
      return true;
    } else {
      message.error('出错了！');
      return false;
    }
  };

  return (
    <>
      {isMobile ? (
        <MobileFeedback
          suggestions={suggestions}
          suggestTypeMap={suggestTypeMap}
          onCreate={handleSubmit}
        />
      ) : (
        <div className={Styles.container}>
          <div className={Styles.wrapper} style={{ minHeight: '656px' }}>
            {success ? (
              <Success text={'您的建议已收到，我们会尽快安排专家与您联系'} />
            ) : (
              <>
                <SuggestHeader {...suggestions} />
                <Form
                  name="basic"
                  initialValues={{ remember: true }}
                  autoComplete="off"
                  layout="vertical"
                  onFinish={(values) => handleSubmit(values)}
                >
                  <Form.Item
                    label="建议类型："
                    name="suggestType"
                    rules={[{ required: true, message: '请选择建议类型' }]}
                  >
                    <Radio.Group>
                      {suggestTypeMap.map((s) => (
                        <Radio value={s.itemValue} key={s.itemValue}>
                          {s.itemName}
                        </Radio>
                      ))}
                    </Radio.Group>
                  </Form.Item>
                  <Form.Item
                    label="标题："
                    name="title"
                    rules={[{ required: true, message: '请输入标题' }]}
                  >
                    <Input placeholder="请输入标题" maxLength={50} />
                  </Form.Item>
                  <Form.Item
                    label="建议内容："
                    name="suggestContent"
                    rules={[{ required: true, message: '请输入建议内容' }]}
                  >
                    <Input.TextArea
                      placeholder="请详细填写您的建议内容，以便我们定位与改进"
                      showCount
                      maxLength={200}
                      className={Styles['text-area']}
                    />
                  </Form.Item>
                  <Contact />
                  <Form.Item
                    name="agreement"
                    rules={[
                      {
                        validator: () => {
                          return agree
                            ? Promise.resolve()
                            : Promise.reject(new Error('请同意服务条款'));
                        },
                      },
                    ]}
                  >
                    <Agreement onChange={(isChecked) => setAgree(isChecked)} />
                  </Form.Item>
                  <Form.Item>
                    <Button
                      type="primary"
                      htmlType="submit"
                      className={Styles['submit-btn']}
                    >
                      提交
                    </Button>
                  </Form.Item>
                </Form>
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
}
